import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';

import Carousel from 'components/Carousel/Carousel';
import type { CarouselItem } from 'components/Carousel/types';
import Grid from 'components/Grid/Grid';
import type { GridItem } from 'components/Grid/types';
import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SectionTitleAndText from 'components/Landing/SectionTitleAndText/SectionTitleAndText';
import { HORIZONTAL_PADDING_MOBILE } from 'components/utilities/pageStyles';
import { getMediaCdnUrl } from 'global/prismicUtils';
import { LayoutSwitch } from 'styles/queries';

import { Image, ImagesWrapper } from './styles';

interface ImageGridProps extends SliceComponentProps<Content.ImageGridSlice> {
  isMobile?: boolean;
}

const ImageGrid: React.FC<ImageGridProps> = ({ slice, isMobile }) => {
  const { gridImageMinWidth, showCarouselForMobile } = slice.primary;

  const images: (GridItem | CarouselItem)[] = slice.items
    .filter(({ image }) => image.url)
    .map(({ image }) => ({
      id: image.url!,
      element: <Image alt={image.alt ?? ''} src={getMediaCdnUrl(image.url!)} />,
    }));

  return (
    <ImagesWrapper>
      {isMobile && showCarouselForMobile !== false ? (
        <Carousel
          centered
          gap={16}
          itemWidth={240}
          items={images}
          snapScrollType="mandatory"
          style={{ margin: `0 -${HORIZONTAL_PADDING_MOBILE}` }}
        />
      ) : (
        <Grid
          items={images}
          maxColumnsCount={3}
          minElementWidth={gridImageMinWidth ?? '180px'}
        />
      )}
    </ImagesWrapper>
  );
};

const Wrapper: React.FC<SliceComponentProps<Content.ImageGridSlice>> = (
  props
) => (
  <ContentWrapper
    background="white"
    className="image-grid"
    customWidth="1440px"
  >
    <SectionTitleAndText slice={props.slice} />
    <LayoutSwitch
      mobileBreakpoint="tabletAndUp"
      mobileProps={{ isMobile: true }}
    >
      <ImageGrid {...props} />
    </LayoutSwitch>
  </ContentWrapper>
);

export default withEventScope(Wrapper, { module: 'imageGrid' });
